export default "__VITE_ASSET__BcmX8Mlb__"